<template>
  <section class="section-product-detail-page bg-primary">

    <div class="bg-grey">
      <h2 class="section-title page-title h2 text-center text-black f-44 h2-caslon">High Performance Plastics</h2>
    </div>

    <div class="container">
      <div class="page-content">
        <div class="content">

          <ContentsTextWithImage
            title="High Performance Plastics"
            image-url="/high-1.jpg"
            :contents="[
              'High performance plastics or specialty resins are plastics whose properties are enhanced to meet specific requirements such as very high heat resistance, extreme chemical resistance, increased wear and friction, thermally and electrically conductive, High stiffness and mechanical properties retention at elevated temperature etc.',
            ]"
            is-white-content="true"
            left-width="39.821%"
            right-width="60.179%"
          />

        </div>
      </div>
    </div>
  </section>

  <section class="section-product-detail-page bg-grey">
    <div class="container page-container">
      <div class="page-content py-0">
        <div class="entry-content">

          <div class="content">

            <h2 class="text-primary">Benefit of High Performance Plastics by NAGASE</h2>
            <p>The outstanding properties of high-performance plastics are superior to those of general plastics in many
              respects. It must withstand heat up to 150 °C, and it may be more than 200 °C as well. It is considered to
              be resistant to high heat many times more than general polymer plastics to support the needs of proper use.
              Furthermore, high-performance plastics also have many important properties, such as</p>
  
            <ul>
              <li>Plastic material is strong and durable, and it maintains its shape well.</li>
              <li>able to prevent chemical reactions.</li>
              <li>It has excellent electrical resistance.</li>
            </ul>

            <div>&nbsp;</div>
  
            <h2 class="text-primary">Typical Characteristics of High Performance Plastics</h2>
            <p>Characteristics of high performance plastics Generally, there are 2 important fundamental characteristics
              to respond to the needs of entrepreneurs of all types of businesses as follows.</p>
  
            <h3 class="text-primary">1. Thermal stability</h3>
            <p>All plastics must have thermal stability properties with added strength and durability from special
              additives such as glass, fiber, carbon fiber, etc. to help increase the mechanical properties for high heat
              resistance. Or if you want to increase the performance even further, Nagase can increase stability by
              replacing aromatic units with aliphatic, allowing plastics to be used at temperatures above 130 °C. That can
              increase the capacity by up to 200 °C.</p>
  
            <h3 class="text-primary">2. Crystallinity</h3>
            <p>Crystallinity is a property of high-performance plastics, which is similar to polymer plastic. But it has a
              high melting point and a phase transition similar to glass materials. If chemicals such as fillers are added
              to increase the strength of the plastic, it will have better mechanical properties. Particularly resistant
              to corrosion and chemical reactions such as organic solvents and acids </p>
  
            <h2 class="text-primary">Applications of High Performance Plastics by NAGASE</h2>
            <p>High-performance plastics <br />from Nagase are ready to meet the needs of business types. who require the
              following materials to create high-quality products for your industries.</p>
  
            <ol style="padding-left: 10px">
              <li>Applications in the aerospace industry that require plastics with special properties and meet specific
                requirements, such as aircraft parts.
              </li>
              <li>Applications in the medical device and equipment industry that must be resistant to chemicals and
                cleaning with specialized disinfectants.
              </li>
              <li>Must have high insulating properties for use in the electrical engineering industry.</li>
              <li>Application in the automotive industry for the production of key automotive components and must be
                highly durable to support heavy use from driving.
              </li>
              <li>Application of plastics in various industries that require the strength and durability of the material,
                whether it is exposed to high heat or exposure to chemicals for a long time.
              </li>
              <li>Application of drilling tools for the crude oil and natural gas industries.</li>
            </ol>

            <p>&nbsp;</p>

            <h2 class="text-primary">Manufacturer Of High Performance Plastics</h2>
            <p>All high-performance plastics products from Nagase are included. suitable for all manufacturing industries
              There are many products to choose from, as follows:</p>

          </div>

        </div>

      </div>
    </div>
  </section>

  <section class="image-gallery bg-grey">
    <div class="container page-container">

      <div class="content px-0">
        <div class="row m-0">
          <div class="col-12">
            <ContentsCard :contents="products[0]"/>
            <ContentsCard :contents="products[1]"/>
            <ContentsCard :contents="products[2]"/>
          </div>
        </div>
      </div>

    </div>
  </section>

</template>
<script setup lang="ts">

useHead({
  title:'High Performance Plastics - NAGASE THAILAND Engineering Plastics',
})

const products = [
  [
    {
      "img":"/pages/products/high-performance-plastics/pei.jpg",
      "title":"PEI (Polyetherimide)",
      "to":"/products/high-performance-plastics/pei"
    },
    {
      "img":"/pages/products/high-performance-plastics/psu.jpg",
      "title":"PSU (Polysulfone)",
      "to":"/products/high-performance-plastics/psu-1"
    },
    {
      "img":"/pages/products/high-performance-plastics/pes.jpg",
      "title":"PES (Polyethersulfone)",
      "to":"/products/high-performance-plastics/pes-2"
    },
  ],
  [
    { 
      "img":"/pages/products/high-performance-plastics/ppsu.jpg",
      "title":"PPSU (Polyphenylsulfone)",
      "to":"/products/high-performance-plastics/ppsu-1"
    },
    {
      "img":"/pages/products/high-performance-plastics/lcp.jpg",
      "title":"LCP (Liquid Crystal Polymer)",
      "to":"/products/high-performance-plastics/lcp-1"
    },
    {
      "img":"/pages/products/high-performance-plastics/pps.jpg",
      "title":"PPS (Polyphenylene Sulfide)",
      "to":"/products/high-performance-plastics/pps-2"
    },
  ],
  [
    {
      "img":"/pages/products/high-performance-plastics/ppa.jpg",
      "title":"PPA (Polyphthalamide)",
      "to":"/products/high-performance-plastics/ppa-2"
    },
    {
      "img":"/pages/products/high-performance-plastics/pa46.jpg",
      "title":"PA46 (Polyamide 46)",
      "to":"/products/high-performance-plastics/pa46-2"
    },
    {
      "img":"/pages/products/high-performance-plastics/sc.jpg",
      "title":"Specialty Compound",
      "to":"/products/high-performance-plastics/specialty-compound"
    }
  ]
]

</script>

<style scoped>
/* p {
  margin: 0px !important;
} */

.entry-content {
  padding-left: 12px;
  padding-right: 12px;
}

.entry-content p {
  margin-bottom: 1.5em;
  line-height: 1.8;
  letter-spacing: -0.2px;
  font-size: 17px;
  color: #5a5d67;
}

.entry-content ul,
.entry-content ol {
  margin-bottom: 0;
}

.entry-content ol li,
.entry-content ul li {
  margin-left: 23px;
  color: #5a5d67;
  font-size: 17px;
  font-weight: 400;
  padding-left: 0;
  letter-spacing: -.2px;
  position: relative;
  margin-bottom: 15px;
}

.image-gallery {
  padding-top: 50px;
}
</style>
